import React from 'react';
import styles from '../TableWidget.module.scss';

export const TableWidgetPlaceholderBlock: React.FC = () => (
  <span className={styles.zeroPlaceholder}>—</span>
);
